export const translations = {
  en: {
    // Header
    nav: {
      home: "Home",
      services: "Services",
      whyChooseUs: "Why Choose Us",
      contact: "Contact",
      getQuote: "Get a Quote"
    },
    topBar: {
      hours: "Mon-Thu: 8:30AM-12PM / 1:30PM-6:30PM, Fri: 8:30AM-12PM / 1:30PM-5:30PM"
    },
    company: {
      name: "ESBLY AUTO - BVA"
    },
    
    // Hero
    hero: {
      badge: "Trusted by 1000+ Customers",
      title1: "Maintenance and Repair",
      title2: "All Makes",
      description: "Complete automotive service with certified technicians. Specialist in automatic transmissions, maintenance, diagnostics and mechanical repair for all vehicle types.",
      experience: "20+ Years Experience",
      warranty: "Warranty Included",
      service: "24-48hr Service",
      cta1: "Get Free Quote",
      cta2: "View Services"
    },
    
    // Services
    services: {
      title: "Our Services",
      subtitle: "Complete automotive maintenance and repair solutions for all makes",
      items: [
        {
          title: "Gearbox Repair",
          description: "Complete diagnostic and repair services for all types of automatic transmissions. Our expert technicians identify and fix issues efficiently."
        },
        {
          title: "General Maintenance",
          description: "Complete vehicle maintenance: oil changes, filters, brake pads, timing belts, and regular inspections to keep your vehicle in perfect condition."
        },
        {
          title: "Diagnostics",
          description: "Advanced electronic diagnostics to identify all vehicle problems. Complete analysis with professional equipment for all brands."
        },
        {
          title: "Braking",
          description: "Complete brake service: pads, discs, calipers, brake fluid. Safety and performance for reliable braking."
        },
        {
          title: "Air Conditioning",
          description: "Air conditioning service and repair, refrigerant recharge, leak detection. Optimal comfort all year round."
        },
        {
          title: "Geometry & Alignment",
          description: "Precise wheel alignment and geometry adjustment. Improved handling and reduced tire wear."
        },
        {
          title: "Bodywork",
          description: "Bodywork repair, painting, dent removal. Restore your vehicle's appearance."
        },
        {
          title: "Pre-MOT Inspection",
          description: "Complete pre-technical inspection to prepare your vehicle. Identify and resolve issues before the official test."
        },
        {
          title: "Wheels & Rims",
          description: "Wheel repair, replacement, and replica rims. Restore the look and performance of your wheels."
        }
      ]
    },
    
    // Why Choose Us
    whyChooseUs: {
      title: "Why Choose Us?",
      description: "We are committed to providing the highest quality automatic gearbox repair and maintenance services. Our team of certified technicians uses the latest diagnostic equipment and quality parts to ensure your vehicle performs at its best.",
      badge: "20+",
      badgeText: "Years Experience",
      features: [
        {
          title: "Expert Technicians",
          description: "Our certified mechanics have over 20 years of combined experience in repair and mechanical maintenance."
        },
        {
          title: "Quality Parts",
          description: "We use OEM and premium aftermarket parts to ensure lasting repairs."
        },
        {
          title: "Fast Service",
          description: "Most repairs completed within 24-48 hours to get you back on the road quickly."
        },
        {
          title: "Warranty Included",
          description: "All our work comes with a comprehensive warranty for your peace of mind."
        }
      ]
    },
    
    // Contact
    contact: {
      title: "Get In Touch",
      subtitle: "Have questions or need a quote? Contact us today and our team will get back to you shortly.",
      infoTitle: "Contact Information",
      infoSubtitle: "Reach out to us through any of the following channels. We're here to help with all your gearbox needs.",
      phone: "Phone",
      email: "Email",
      address: "Address",
      hours: "Business Hours",
      formTitle: "Send Us a Message",
      form: {
        name: "Full Name",
        nameRequired: "Full Name *",
        namePlaceholder: "John Doe",
        email: "Email Address",
        emailRequired: "Email Address *",
        emailPlaceholder: "john@example.com",
        phone: "Phone Number",
        phonePlaceholder: "+1 (555) 123-4567",
        vehicle: "Vehicle Make & Model",
        vehiclePlaceholder: "e.g., Toyota Camry 2020",
        registration: "License Plate",
        registrationPlaceholder: "e.g., AB-123-CD",
        message: "Message",
        messageRequired: "Message *",
        messagePlaceholder: "Tell us about your gearbox issue...",
        submit: "Send Message",
        sending: "Sending..."
      },
      success: "Success!",
      successMessage: "Thank you for contacting us! We'll get back to you soon.",
      error: "Error",
      errorMessage: "Something went wrong. Please try again."
    },
    
    // Footer
    footer: {
      description: "ESBLY AUTO - BVA, your trusted Bosch Service partner for professional automatic gearbox repair and maintenance.",
      quickLinks: "Quick Links",
      ourServices: "Our Services",
      contactUs: "Contact Us",
      copyright: "ESBLY AUTO - BVA. Tous droits réservés.",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      services: [
        "Gearbox Repair",
        "Preventive Maintenance",
        "Advanced Diagnostics",
        "Gearbox Replacement",
        "Clutch Services",
        "Performance Tuning"
      ]
    }
  },
  
  fr: {
    // Header
    nav: {
      home: "Accueil",
      services: "Services",
      whyChooseUs: "Pourquoi Nous",
      contact: "Contact",
      getQuote: "Devis Gratuit"
    },
    topBar: {
      hours: "Lun-Jeu: 8h30-12h / 13h30-18h30, Ven: 8h30-12h / 13h30-17h30"
    },
    company: {
      name: "ESBLY AUTO - BVA"
    },
    
    // Hero
    hero: {
      badge: "Approuvé par 1000+ Clients",
      title1: "Entretien et Réparation",
      title2: "Toutes Marques",
      description: "Garage automobile complet avec des techniciens certifiés. Spécialiste boîtes automatiques, entretien, diagnostic et réparation mécanique pour tous types de véhicules.",
      experience: "20+ Ans d'Expérience",
      warranty: "Garantie Incluse",
      service: "Service 24-48h",
      cta1: "Devis Gratuit",
      cta2: "Voir Services"
    },
    
    // Services
    services: {
      title: "Nos Services",
      subtitle: "Solutions complètes d'entretien et de réparation automobile pour toutes les marques",
      items: [
        {
          title: "Réparation de Boîte",
          description: "Services complets de diagnostic et de réparation pour tous les types de transmissions automatiques. Nos techniciens experts identifient et résolvent les problèmes efficacement."
        },
        {
          title: "Entretien Général",
          description: "Entretien complet du véhicule : vidanges, filtres, plaquettes de frein, courroies de distribution et contrôles réguliers pour maintenir votre véhicule en parfait état."
        },
        {
          title: "Diagnostic",
          description: "Diagnostic électronique avancé pour identifier tous les problèmes du véhicule. Analyse complète avec équipement professionnel pour toutes marques."
        },
        {
          title: "Freinage",
          description: "Service complet de freinage : plaquettes, disques, étriers, liquide de frein. Sécurité et performance pour un freinage fiable."
        },
        {
          title: "Climatisation",
          description: "Entretien et réparation de climatisation, recharge de fluide frigorigène, détection de fuites. Confort optimal toute l'année."
        },
        {
          title: "Géométrie & Parallélisme",
          description: "Réglage précis de la géométrie et du parallélisme des roues. Meilleure tenue de route et réduction de l'usure des pneus."
        },
        {
          title: "Carrosserie",
          description: "Réparation de carrosserie, peinture, débosselage. Restaurez l'apparence de votre véhicule."
        },
        {
          title: "Pré-Contrôle Technique",
          description: "Inspection complète avant le contrôle technique pour préparer votre véhicule. Identification et résolution des problèmes avant le test officiel."
        },
        {
          title: "Jantes",
          description: "Réparation de jantes, remplacement et répliques. Restaurez l'apparence et les performances de vos roues."
        }
      ]
    },
    
    // Why Choose Us
    whyChooseUs: {
      title: "Pourquoi Nous Choisir?",
      description: "Nous nous engageons à fournir des services de réparation et d'entretien de boîte automatique de la plus haute qualité. Notre équipe de techniciens certifiés utilise les derniers équipements de diagnostic et des pièces de qualité pour garantir les meilleures performances de votre véhicule.",
      badge: "20+",
      badgeText: "Ans d'Expérience",
      features: [
        {
          title: "Techniciens Experts",
          description: "Nos mécaniciens certifiés ont plus de 20 ans d'expérience combinée en réparation et entretien mécanique."
        },
        {
          title: "Pièces de Qualité",
          description: "Nous utilisons des pièces OEM et de rechange haut de gamme pour garantir des réparations durables."
        },
        {
          title: "Service Rapide",
          description: "La plupart des réparations sont effectuées dans les 24 à 48 heures pour vous remettre rapidement sur la route."
        },
        {
          title: "Garantie Incluse",
          description: "Tous nos travaux sont assortis d'une garantie complète pour votre tranquillité d'esprit."
        }
      ]
    },
    
    // Contact
    contact: {
      title: "Contactez-Nous",
      subtitle: "Des questions ou besoin d'un devis? Contactez-nous dès aujourd'hui et notre équipe vous répondra rapidement.",
      infoTitle: "Informations de Contact",
      infoSubtitle: "Contactez-nous via l'un des canaux suivants. Nous sommes là pour vous aider avec tous vos besoins en boîte de vitesses.",
      phone: "Téléphone",
      email: "Email",
      address: "Adresse",
      hours: "Heures d'Ouverture",
      formTitle: "Envoyez-nous un Message",
      form: {
        name: "Nom Complet",
        nameRequired: "Nom Complet *",
        namePlaceholder: "Jean Dupont",
        email: "Adresse Email",
        emailRequired: "Adresse Email *",
        emailPlaceholder: "jean@exemple.com",
        phone: "Numéro de Téléphone",
        phonePlaceholder: "+33 1 23 45 67 89",
        vehicle: "Marque et Modèle du Véhicule",
        vehiclePlaceholder: "ex: Renault Clio 2020",
        registration: "Immatriculation",
        registrationPlaceholder: "ex: AB-123-CD",
        message: "Message",
        messageRequired: "Message *",
        messagePlaceholder: "Parlez-nous de votre problème de boîte de vitesses...",
        submit: "Envoyer le Message",
        sending: "Envoi en cours..."
      },
      success: "Succès!",
      successMessage: "Merci de nous avoir contactés! Nous vous répondrons bientôt.",
      error: "Erreur",
      errorMessage: "Quelque chose s'est mal passé. Veuillez réessayer."
    },
    
    // Footer
    footer: {
      description: "ESBLY AUTO - BVA, votre partenaire agréé Bosch Service pour la réparation et l'entretien professionnel de boîtes automatiques.",
      quickLinks: "Liens Rapides",
      ourServices: "Nos Services",
      contactUs: "Contactez-Nous",
      copyright: "ESBLY AUTO - BVA. Tous droits réservés.",
      privacy: "Politique de Confidentialité",
      terms: "Conditions d'Utilisation",
      services: [
        "Réparation de Boîte",
        "Entretien Préventif",
        "Diagnostic Avancé",
        "Remplacement de Boîte",
        "Services d'Embrayage",
        "Réglage Performance"
      ]
    }
  }
};
